import { CostSellModelType } from '@teinor/erp/types/company/config/cost/costSell'

export interface CostSellsAction {
    type: 'CHANGE_COSTSELL'
    payload: CostSellModelType[]
}
export type CostSellPayload = { active: { [id: number]: CostSellModelType }, all: { [id: number]: CostSellModelType } } | null

export default function costsSell(state: CostSellPayload = null, action: CostSellsAction): CostSellPayload {
    switch (action.type) {
        case 'CHANGE_COSTSELL':
            let costsSell: CostSellPayload = {
                active: {},
                all: {}
            }
            for (const element of action.payload) {
                if (element.active) {
                    costsSell.active[element.id] = element
                }
                costsSell.all[element.id] = element
            }
            return state = costsSell
        default:
            return state
    }
}